// import { useState, useEffect, useCallback } from "react";
// import { toast } from "react-toastify";
// import { getSubscriptionByIdApi } from "../../apis/subscriptionApi";

// export const useSubscription = (subscriptionId) => {
//   const [subscription, setSubscription] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const fetchSubscription = useCallback(async () => {
//     if (!subscriptionId) return;

//     setLoading(true);
//     setError(null);

//     // const toastId = toast.loading("Loading subscription details...");

//     try {
//      const res = await getSubscriptionByIdApi(subscriptionId);
//     setSubscription(res.data);  
//     //   toast.update(toastId, {
//     //     render: "Subscription loaded",
//     //     type: "success",
//     //     isLoading: false,
//     //     autoClose: 1400,
//     //   });
//     } catch (err) {
//       const msg = err.message || "Failed to load subscription";
//       setError(msg);
//       toast.update( {
//         render: msg,
//         type: "error",
//         isLoading: false,
//         autoClose: 4000,
//       });
//     } finally {
//       setLoading(false);
//     }
//   }, [subscriptionId]);

//   useEffect(() => {
//     fetchSubscription();
//   }, [fetchSubscription]);

//   return { subscription, loading, error, refetch: fetchSubscription };
// };

import { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import { getSubscriptionByIdApi } from "../../apis/subscriptionApi";

export const useSubscription = (subscriptionId) => {
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const extractError = (err) => {
   // err is the plain object thrown by projectApi's handleApiError:
      // { status, message, data }
      return {
        title: err.message || "Update Failed",
        issue:
          err.data?.data ||   // "images: The submitted data was not a file..."
          err.message ||
        "Failed to load subscription.",
    };
  };

  const fetchSubscription = useCallback(async () => {
    if (!subscriptionId) return;

    setLoading(true);
    setError(null);

    try {
      const res = await getSubscriptionByIdApi(subscriptionId);
      setSubscription(res?.data || res);
    } catch (err) {
      const { title, issue } = extractError(err);

      toast.error(
        <div>
          <strong>{title}</strong>
          <div>{issue}</div>
        </div>
      );

      setError({ title, issue });
    } finally {
      setLoading(false);
    }
  }, [subscriptionId]);

  useEffect(() => {
    fetchSubscription();
  }, [fetchSubscription]);

  return { subscription, loading, error, refetch: fetchSubscription };
};